"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordInputControl = void 0;
const react_1 = __importStar(require("react"));
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const doshx_controls_web_1 = require("doshx_controls_web");
function PasswordInputControl({ label, value, errorText, borderColor, onChange, }) {
    const [showPassword, setShowPassword] = (0, react_1.useState)(false);
    return (react_1.default.createElement("div", { className: "relative" },
        react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: label, type: showPassword ? "text" : "password", value: value, errorText: errorText, borderColor: borderColor, onChange: onChange }),
        react_1.default.createElement("button", { type: "button", "aria-label": showPassword ? "Hide password" : "Show password", "aria-pressed": showPassword, className: "absolute right-3 top-[38px] rounded-sm text-gray-400 hover:text-gray-600 focus-visible:ring-2 focus-visible:ring-primary/30", onClick: () => setShowPassword((current) => !current) },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: showPassword ? pro_light_svg_icons_1.faEyeSlash : pro_light_svg_icons_1.faEye, size: "sm" }))));
}
exports.PasswordInputControl = PasswordInputControl;
